class accordionItem extends HTMLElement {
  constructor() {
    super();

    this.accordionHeader = this.querySelector(".js-accordion-header");
    this.accordionPanel = this.querySelector(".js-accordion-panel");

    this.init();
    window.addEventListener("resize", this.init.bind(this));
  };

  init() {
      if(document.documentElement.clientWidth > 767) {
          this.accordionHeader.removeEventListener("click", this.toggleAccordion.bind(this));
      }else {
          this.accordionHeader.addEventListener("click", this.toggleAccordion.bind(this));
      }
  };
  
  toggleAccordion() {
      var height = this.accordionPanel.querySelector(".footer_collabsible--content").offsetHeight;
      this.classList.toggle("is-open");

      if(this.classList.contains("is-open")) {
          this.accordionPanel.style = `height: ${height}px`;
      }else {
          this.accordionPanel.style = "height: 0px";
      }
  };
}

customElements.define('accordion-item', accordionItem);
